import React, { Component } from 'react';
import FilteredList2 from './filteredList2';
import UserForm from './userForm';
import { end_point } from './helper';


class Users2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterableFields: ["first_name", "last_name", "type", "secondary_contact_name"],
      labelFields: [
        { "displayName":"Participant", "name":"participant_name", "size": "22%" },
        { "displayName":"Account Holder", "name":"account_holder", "size": "22%" },
        { "displayName":"Secondary Contact", "name":"secondary_contact_name", "size": "22%" },
        { "displayName":"Type", "name":"type", "size": "12%" },
        { "displayName":"Actions", "name":"archive", "size": "10%"}
      ],
      endpoint: `${end_point('users')}/users`
    }
  }

  render() {
    return (
      <FilteredList2 heading="Users" filterableFields={this.state.filterableFields} labelFields={this.state.labelFields} endpoint={this.state.endpoint}>
        <UserForm />
      </FilteredList2>
    );
  }
}

export default Users2;
